import { isLineItemReorderable } from "../../../../../../../utils/Orders/utils/is-line-item-reorderable.js";
import { getPrices } from "../../../../../utils/Orders/mappers/view/utils/get-prices.js";
import { getProductA11yLabel } from "../../../../../utils/Orders/mappers/view/utils/get-product-a11y-label.js";
import { getProductSubtitle } from "../../../../../utils/Orders/mappers/view/utils/get-product-subtitle.js";
import { getProductTitle } from "../../../../../utils/Orders/mappers/view/utils/get-product-title.js";
import { createImageUrl } from "../../../../../utils/Orders/mappers/view/utils/create-image-url.js";
const mapProductType = (serverType) => {
  switch (serverType.toLowerCase()) {
    case "frames":
      return "frames";
    case "sunglasses":
      return "sunglasses";
    case "solutions":
      return "solutions";
    case "ready_readers":
      return "ready-readers";
    case "accessories":
      return "accessories";
    default:
      return "sunglasses";
  }
};
const toBaseLineItem = (orderLineItem, intl, options = {}) => {
  const priceDetails = getPrices(orderLineItem);
  return {
    id: orderLineItem.id,
    lineItemId: orderLineItem.id,
    productType: mapProductType(orderLineItem.product.productType),
    // TODO: MACC-15487 - Remove originalProductType once we have a proper solution for the productType mapping
    originalProductType: mapProductType(orderLineItem.product.productType),
    quantity: `${intl.getLabel("cart.item.quantity")}: ${orderLineItem.quantity}`,
    sku: orderLineItem.product.sku,
    isSkuPublished: orderLineItem.product.currentProduct?.published ?? false,
    imageUrl: createImageUrl(orderLineItem.product.mainImage, options),
    title: getProductTitle(orderLineItem, intl),
    subtitle: getProductSubtitle(orderLineItem, intl),
    altText: getProductA11yLabel(orderLineItem, intl),
    isReorderAvailable: isLineItemReorderable(orderLineItem),
    slug: orderLineItem.product.currentProduct?.slug ?? void 0,
    insurance: orderLineItem.insurance,
    deliveryEstimation: orderLineItem.deliveryEstimation,
    ...priceDetails
  };
};
export {
  toBaseLineItem
};
//# sourceMappingURL=base-line-item.js.map
